
(function () {
    window.WatchlistApp = window.WatchlistApp || {};

    const Manager = {
        async checkAuthorization() {
            try {
                if (typeof window.AuthAPI !== 'undefined' && typeof window.AuthAPI.getStoredSession === 'function') {
                    const session = window.currentSession || window.AuthAPI.getStoredSession();
                    if (!session) {
                        return { authorized: false, message: 'Log in to access watchlist' };
                    }
                    if (session.user && session.user.is_anonymous) {
                        return { authorized: false, message: 'Register with email to create and manage watchlists' };
                    }
                    return { authorized: true, message: '' };
                }
            } catch (e) {
                console.warn('Error checking session auth state:', e);
            }
            
            // Fallback to manual check if AuthAPI not available or error occurred
            let session = window.currentSession;
            if (!session) {
                try {
                    const sessionStr = localStorage.getItem('auth_session');
                    if (sessionStr) {
                        const parsed = JSON.parse(sessionStr);
                        session = parsed.value || parsed;
                    }
                } catch (_) {}
            }

            if (!session) {
                return { authorized: false, message: 'Log in to access watchlist' };
            }

            if (session.user && session.user.is_anonymous) {
                return { authorized: false, message: 'Register with email to create and manage watchlists' };
            }

            return { authorized: true, message: '' };
        },

        updateWatchlistState: async function () {
            const State = window.WatchlistApp.State;
            let userId = null;
            let watchlists = [];
            try {
                if (typeof window.WatchlistAPIManager === 'undefined') {
                    console.warn('[WatchlistManager] WatchlistAPIManager not ready yet.');
                    return { userId, watchlists };
                }
                const data = await WatchlistAPIManager.instance.getWatchlists();
                if (data && data.watchlists) {
                    watchlists = Array.isArray(data.watchlists) ? data.watchlists : (data.watchlists.watchlists || []);
                    userId = data.user_id;
                    State.allWatchlists = watchlists;
                    State.currentUserId = userId;
                }
            } catch (e) {
                console.error('[WatchlistManager] Error fetching watchlists:', e);
            }
            return { userId, watchlists };
        },

        isPremiumUser: function () {
            return false;
        },

        loadWatchlistData: async function (userId, watchlistId, excludedTickers = [], intervalOverride = null, renderVisuals = true) {
            const State = window.WatchlistApp.State;
            State.currentUserId = userId;
            State.currentWatchlistId = watchlistId;

            if (!watchlistId) return;

            const stockCube = document.getElementById('stock-3d-cube');
            let currentInterval = intervalOverride;
            if (!currentInterval && stockCube) {
                currentInterval = stockCube.getAttribute('stock-cube-visualizer')?.interval;
            }
            if (!currentInterval) currentInterval = '1d';
            currentInterval = currentInterval.toLowerCase();

            try {
                const apiResponse = await WatchlistAPIManager.instance.getWatchlistReports(currentInterval, userId, watchlistId);

                let finalReportData = { intervals: {}, stockInfo: {} };

                if (apiResponse && apiResponse.response && apiResponse.response.data) {
                    const r = apiResponse.response;
                    const headers = r.headers || [];
                    const data = r.data || {};
                    const tickerDetailsMap = r.ticker_info || {};

                    const idxTicker = headers.indexOf('ticker');
                    const idxPrice = headers.indexOf('price');
                    const idxChangePct = headers.indexOf('price_pct_change_vs_prev_close');
                    const idxChange = headers.indexOf('price_change_vs_prev_close');
                    const idxVol = headers.indexOf('volume');
                    const idxRvp = headers.indexOf('daypart_relative_volume_percentage');

                    Object.keys(data).forEach(timeKey => {
                        const rows = data[timeKey];
                        let cleanTimeKey = timeKey.replace(' EST', '').replace(' EDT', '').trim();
                        cleanTimeKey = cleanTimeKey.replace('T', ' ').replace('Z', '').split('.')[0];

                        finalReportData.intervals[cleanTimeKey] = [];

                        rows.forEach(row => {
                            const ticker = row[idxTicker];
                            if (!ticker) return;
                            if (excludedTickers && excludedTickers.includes(ticker)) return;

                            const price = parseFloat(row[idxPrice]) || 0;
                            const changePct = parseFloat(row[idxChangePct]) || 0;
                            const change = parseFloat(row[idxChange]) || 0;
                            const vol = parseFloat(row[idxVol]) || 0;
                            const rvp = idxRvp !== -1 ? (parseFloat(row[idxRvp]) || 0) : 0;

                            const details = tickerDetailsMap[ticker] || { name: ticker };

                            const stockObj = {
                                ticker: ticker,
                                price: price,
                                todaysChangePerc: changePct,
                                todaysChange: change,
                                daypart_relative_volume_percentage: rvp,
                                day: { c: price, v: vol },
                                tickerDetails: {
                                    name: details.name || ticker,
                                    primary_exchange: details.primary_exchange
                                },
                                timestamp: timeKey,
                            };

                            finalReportData.intervals[cleanTimeKey].push(stockObj);
                        });
                    });

                    const timeKeys = Object.keys(finalReportData.intervals).sort();
                    const lastTimeKey = timeKeys[timeKeys.length - 1];

                    if (lastTimeKey) {
                        const lastIntervalData = finalReportData.intervals[lastTimeKey];
                        lastIntervalData.forEach(item => {
                            finalReportData.stockInfo[item.ticker] = { ...item };
                        });
                    }
                }

                const currentWatchlist = State.allWatchlists.find(w => String(w.id) === String(watchlistId));
                if (!currentWatchlist) {
                    console.warn(`[WatchlistManager] Current watchlist NOT found in State.allWatchlists! Searched ID: ${watchlistId}. Available IDs: ${State.allWatchlists.map(w => w.id).join(', ')}`);
                }
                const holdings = currentWatchlist ? currentWatchlist.holdings : {};
                const applyHoldingToStock = (stockObj, ticker) => {
                    let qty = 0;
                    let totalCost = 0;

                    if (holdings && holdings[ticker]) {
                        qty = parseFloat(holdings[ticker].quantity) || 0;
                        totalCost = parseFloat(holdings[ticker].price) || 0;
                    }

                    stockObj.quantity = qty;
                    stockObj.userHolding = {
                        quantity: qty,
                        price: totalCost
                    };

                    const currentPrice = parseFloat(stockObj.price || stockObj.day?.c || 0);

                    if (totalCost > 0) {
                        const currentTotalValue = currentPrice * qty;
                        const diff = currentTotalValue - totalCost;
                        stockObj.totalChangeDollar = diff;
                        stockObj.totalChangePercent = (diff / totalCost) * 100;
                    } else {
                        stockObj.totalChangeDollar = 0;
                        stockObj.totalChangePercent = 0;
                    }
                };

                Object.keys(finalReportData.stockInfo).forEach(ticker => {
                    applyHoldingToStock(finalReportData.stockInfo[ticker], ticker);
                });

                if (finalReportData.intervals) {
                    Object.keys(finalReportData.intervals).forEach(tsKey => {
                        const intervalArr = finalReportData.intervals[tsKey];
                        if (Array.isArray(intervalArr)) {
                            intervalArr.forEach(stockItem => {
                                applyHoldingToStock(stockItem, stockItem.ticker);
                            });
                        }
                    });
                }

                if (window.WatchlistApp.Summary && window.WatchlistApp.Summary.calculateSummary) {
                    State.summary = window.WatchlistApp.Summary.calculateSummary(finalReportData, holdings, currentInterval);
                } else {
                    console.warn('[WatchlistManager] Summary service or calculateSummary not found. window.WatchlistApp.Summary is:', window.WatchlistApp.Summary);
                }

                const stockCount = Object.keys(finalReportData.stockInfo || {}).length;

                State.lastReportData = finalReportData;
                State.currentWatchlistData = Object.values(finalReportData.stockInfo || {});

                document.body.dispatchEvent(new CustomEvent('watchlist-data-loaded', {
                    detail: {
                        stockInfo: State.currentWatchlistData,
                        totalStocks: stockCount
                    },
                    bubbles: true
                }));

                if (renderVisuals) {
                    let stockCube = document.getElementById('stock-3d-cube');
                    if (!stockCube) {
                        stockCube = document.querySelector('[stock-cube-visualizer]');
                    }

                    if (stockCube) {
                        stockCube.dispatchEvent(new CustomEvent('watchlist-injected-data', {
                            detail: finalReportData,
                            bubbles: false
                        }));

                        stockCube.setAttribute('stock-cube-visualizer', {
                            dataSource: 'watchlist-reports',
                            interval: currentInterval,
                            userId: userId,
                            watchlistId: watchlistId,
                            excludedTickers: excludedTickers || [],
                            injectedData: ''
                        });
                    } else {
                        console.warn('[WatchlistManager] stock-3d-cube not found for visual update');
                    }
                }

            } catch (err) {
                console.error('[WatchlistManager] Error loading watchlist data:', err);
            }
        },
        async deleteWatchlist(id) {
            try {
                if (typeof WatchlistAPIManager === 'undefined') {
                    console.error('[WatchlistManager] WatchlistAPIManager not available');
                    return { success: false };
                }
                const res = await WatchlistAPIManager.instance.deleteWatchlist(id);
                if (res && res.success) {
                    await this.updateWatchlistState();
                    return { success: true };
                }
                return { success: false };
            } catch (e) {
                console.error('[WatchlistManager] Error deleting watchlist:', e);
                return { success: false };
            }
        },

        async applyWatchlistEdits(draftState) {
            try {
                const api = window.WatchlistAPIManager && window.WatchlistAPIManager.instance;
                if (!api) throw new Error('WatchlistAPIManager not available');

                const {
                    deletedWatchlistIds,
                    allWatchlists,
                    currentWatchlistId,
                    currentUserId,
                    csvCurrentImportTickers,
                    currentWatchlistData
                } = draftState;

                if (deletedWatchlistIds && deletedWatchlistIds.size > 0) {
                    for (const id of deletedWatchlistIds) {
                        await api.deleteWatchlist(id);
                    }
                }

                const idMap = {};
                const watchlists = [...allWatchlists];
                for (let i = 0; i < watchlists.length; i++) {
                    const wl = watchlists[i];
                    if (String(wl.id).indexOf('temp_') === 0) {
                        const res = await api.createWatchlist(wl.name);
                        if (res && (res.id || (res.watchlist && res.watchlist.id))) {
                            const realId = res.id || (res.watchlist && res.watchlist.id);
                            idMap[wl.id] = realId;
                            wl.id = realId;
                        } else {
                            console.error('[WatchlistManager] Failed to create watchlist', wl.name);
                        }
                    }
                }

                let finalCurrentId = currentWatchlistId;
                if (String(finalCurrentId).indexOf('temp_') === 0) {
                    if (idMap[finalCurrentId]) {
                        finalCurrentId = idMap[finalCurrentId];
                    }
                }

                window.WatchlistApp.State.currentWatchlistId = finalCurrentId;

                for (const wl of watchlists) {
                    await api.updateWatchlist(wl.id, wl.name, wl.tickers, wl.holdings);
                }

                await this.updateWatchlistState();

                if (finalCurrentId) {
                    let shouldRender = false;
                    const cube = document.getElementById('stock-3d-cube');
                    if (cube) {
                        const attr = cube.getAttribute('stock-cube-visualizer');
                        if (attr && attr.dataSource === 'watchlist-reports') {
                            shouldRender = true;
                        }
                    }

                    if (shouldRender || (csvCurrentImportTickers && csvCurrentImportTickers.size > 0)) {
                        await this.loadWatchlistData(currentUserId, finalCurrentId, [], null, shouldRender);
                    }
                } else {
                    let shouldClearVisuals = false;
                    const cube = document.getElementById('stock-3d-cube');
                    if (cube) {
                        const attr = cube.getAttribute('stock-cube-visualizer');
                        if (attr && attr.dataSource === 'watchlist-reports') {
                            shouldClearVisuals = true;
                        }
                    }

                    if (this.clearWatchlistData) {
                        this.clearWatchlistData(shouldClearVisuals);
                    }
                }

                if (csvCurrentImportTickers && csvCurrentImportTickers.size > 0 && window.WatchlistApp.State.currentWatchlistData) {
                    const loadedTickers = new Set(window.WatchlistApp.State.currentWatchlistData.map(s => s.ticker));
                    const missingTickers = [];
                    csvCurrentImportTickers.forEach(ticker => {
                        if (!loadedTickers.has(ticker)) {
                            missingTickers.push(ticker);
                        }
                    });

                    if (missingTickers.length > 0) {
                        console.warn('[WatchlistManager] Post-save verification found missing tickers:', missingTickers);
                        if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showNotificationPopup) {
                            const displayList = missingTickers.length > 5
                                ? missingTickers.slice(0, 5).join(', ') + `... (+${missingTickers.length - 5} more)`
                                : missingTickers.join(', ');

                            window.WatchlistApp.Popup.showNotificationPopup(
                                'Tickers Not Added',
                                `The following ${missingTickers.length} ticker(s) were not added (likely unsupported):<br><b>${displayList}</b>`
                            );
                        }
                    }
                }

                return { success: true };
            } catch (e) {
                console.error('[WatchlistManager] _processSave error:', e);
                return { success: false, error: e };
            }
        },

        async createWatchlist(name) {
            if (!name) return { success: false };
            if (name.length > 50) return { success: false };
            if (/[^\x00-\x7F]/.test(name)) return { success: false };

            try {
                if (typeof WatchlistAPIManager === 'undefined') {
                    console.warn('[WatchlistManager] WatchlistAPIManager not ready.');
                    return { success: false };
                }
                const res = await WatchlistAPIManager.instance.createWatchlist(name);
                if (res && (res.success || res.id || res.watchlist)) {
                    const { userId, watchlists } = await this.updateWatchlistState();

                    let shouldRenderVisuals = false;
                    const stockCube = document.getElementById('stock-3d-cube');
                    if (stockCube) {
                        const attr = stockCube.getAttribute('stock-cube-visualizer');
                        if (attr && attr.dataSource === 'watchlist-reports') {
                            shouldRenderVisuals = true;
                        }
                    }

                    const newWl = watchlists.find(w => w.name === name);
                    if (newWl) {
                        await this.loadWatchlistData(userId, newWl.id, [], null, shouldRenderVisuals);
                        return { success: true, watchlist: newWl };
                    }
                    return { success: true };
                }
            } catch (e) {
                console.error('[WatchlistManager] Error creating watchlist:', e);
            }
            return { success: false };
        },

        clearWatchlistData: function (renderVisuals = true) {
            const State = window.WatchlistApp.State;
            const Summary = window.WatchlistApp.Summary;

            State.currentWatchlistId = null;
            State.currentWatchlistData = [];
            State.totalStocks = 0;
            State.lastReportData = null;
            State.summary = null;

            if (renderVisuals) {
                const stockCube = document.getElementById('stock-3d-cube');

                if (window.Fireworks && window.Fireworks.emergencyStopFireworks) {
                    window.Fireworks.emergencyStopFireworks();
                }

                if (stockCube) {
                    const currentSource = stockCube.getAttribute('stock-cube-visualizer')?.dataSource;

                    const chartControlEl = document.querySelector('[chart-type-control]');
                    let resetSuccessful = false;

                    if (chartControlEl && chartControlEl.components && chartControlEl.components['chart-type-control']) {
                        const chartControl = chartControlEl.components['chart-type-control'];

                        chartControlEl.setAttribute('chart-type-control', 'selectedPrimeAction', 'topdollar');
                        chartControlEl.setAttribute('chart-type-control', 'selectedSecondaryAction', 'gen');

                        if (chartControl.selectedButton3DFrame) {
                            chartControl.selectedButton3DFrame.position.x = -12.4 * 1.12; 
                        }

                        chartControl.updateChartType(true);
                        resetSuccessful = true;
                    } else {
                        console.error('[WatchlistManager] chart-type-control component not found on element');
                    }

                    if (!resetSuccessful) {
                        console.warn('[WatchlistManager] Chart control component not found, emitting chart-type-changed fallback');
                        document.querySelector('a-scene')?.emit('chart-type-changed', { action: 'topdollar' });

                        if (currentSource === 'watchlist-reports') {
                            stockCube.dispatchEvent(new CustomEvent('watchlist-injected-data', {
                                detail: { intervals: {}, stockInfo: {} },
                                bubbles: false
                            }));
                            stockCube.setAttribute('stock-cube-visualizer', {
                                dataSource: 'top-gainers',
                                watchlistId: null,
                                injectedData: ''
                            });
                        }
                    }
                }
            }

            const popupIds = [
                { id: 'edit-watchlist-popup', component: 'edit-watchlist' },
                { id: 'add-unit-vr-popup', component: 'add-unit-vr-popup' },
                { id: 'add-to-watchlist-vr-popup', component: 'add-to-watchlist-vr-popup' },
                { id: 'watchlist-input-vr-popup', component: 'watchlist-input-popup' },
                { id: 'watchlist-confirmation-vr-popup', component: 'watchlist-confirmation-popup' },
                { id: 'watchlist-notification-vr-popup', component: 'watchlist-notification-popup' },
                { id: 'edit-holdings-vr-popup', component: 'edit-holdings-vr-popup' }
            ];

            popupIds.forEach(p => {
                const el = document.getElementById(p.id);
                if (el && el.components && el.components[p.component]) {
                    if (typeof el.components[p.component].close === 'function') {
                        el.components[p.component].close();
                    } else {
                        el.setAttribute('visible', false);
                    }
                } else if (el) {
                    el.setAttribute('visible', false);
                }
            });

            document.body.dispatchEvent(new CustomEvent('watchlist-data-loaded', {
                detail: {
                    stockInfo: [],
                    totalStocks: 0
                },
                bubbles: true
            }));
        }
    };

    window.WatchlistApp.Manager = Manager;

    document.addEventListener('DOMContentLoaded', () => {
        const editBtn = document.getElementById('edit-watchlist-btn');
        if (editBtn) {
            editBtn.addEventListener('click', () => {
                if (window.PopupManager) {
                    window.PopupManager.open('edit-watchlist-popup');
                } else {
                    const popup = document.getElementById('edit-watchlist-popup');
                    if (popup && popup.components['edit-watchlist']) {
                        popup.components['edit-watchlist'].open();
                    }
                }
            });
        }

        const selectBtn = document.getElementById('select-watchlist-btn');
        if (selectBtn) {
            selectBtn.addEventListener('click', () => {
                if (window.WatchlistApp && window.WatchlistApp.Popup && window.WatchlistApp.Popup.showPremiumLimitPopup) {
                    window.WatchlistApp.Popup.showPremiumLimitPopup();
                }
            });
        }

        let checks = 0;
        const maxChecks = 100;
        const interval = setInterval(async () => {
            checks++;
            if (window.userInitialized || checks >= maxChecks) {
                clearInterval(interval);
                if (window.currentSession) {
                    const { userId, watchlists } = await Manager.updateWatchlistState();

                    if (watchlists && watchlists.length > 0) {
                        const firstWl = watchlists[0];
                        await Manager.loadWatchlistData(userId, firstWl.id, [], null, false);
                    }
                } else {
                    // If no session but we've waited, try one more time to fetch in case initializeUserOnce is slow
                    await Manager.updateWatchlistState();
                }
            }
        }, 50);
    });

    document.addEventListener('auth:session-changed', async (e) => {
        const session = e.detail.session;
        console.log('[WatchlistManager] auth:session-changed', { hasSession: !!session });
        if (session) {
            const { userId, watchlists } = await Manager.updateWatchlistState();

            if (watchlists && watchlists.length > 0) {
                const State = window.WatchlistApp.State;
                if (!State.currentWatchlistId || !State.currentWatchlistData || State.currentWatchlistData.length === 0) {
                    const firstWl = watchlists[0];
                    let shouldRenderVisuals = false;
                    const stockCube = document.getElementById('stock-3d-cube');
                    if (stockCube) {
                        const attr = stockCube.getAttribute('stock-cube-visualizer');
                        if (attr && attr.dataSource === 'watchlist-reports') {
                            shouldRenderVisuals = true;
                        }
                    }
                    await Manager.loadWatchlistData(userId, firstWl.id, [], null, shouldRenderVisuals);
                }
            }
        } else {
            Manager.clearWatchlistData();
        }
    });

})();
